const copyToBuffer = (text: string) => {
  const clipboardPromise = navigator.permissions.query({ name: 'clipboard-write' as PermissionName });

  if (typeof clipboardPromise.then === 'function') {
    clipboardPromise
      .then((result) => {
        if (result.state === 'granted') {
          void navigator.clipboard.writeText(text);
        }
      })
      .catch((error: unknown) => {
        console.error('Getting clipboard permission failed:', error);
        void navigator.clipboard.writeText(text);
      });
  }
};

export { copyToBuffer };
